<template>
  <BillingLineItemCell>
    <div :class="{ 'billing-line-item-label': emphasized }">
      {{ label }}
    </div>
    <div class="billing-line-item-label-subtext" v-if="subtext">
      {{ subtext }}
    </div>
  </BillingLineItemCell>
</template>

<script>
import BillingLineItemCell from './BillingLineItemCell.vue';

export default {
  name: 'BillingLineItemLabel',
  components: { BillingLineItemCell },
  props: {
    label: {
      type: String,
    },
    subtext: {
      type: String,
    },
    emphasized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.billing-line-item-label {
  font-weight: 500;
}
.billing-line-item-label-subtext {
  font-size: 0.875rem;
  color: #666;
}
</style>
